export const formatPathWithConfigAppBackend = (path: string) =>
  path.replace(
    /attributes\./,
    !path.includes('domainEntityAttributes')
      ? 'attributes.domainEntityAttributes.'
      : 'attributes.',
  );
